module.exports = __webpack_public_path__ + "img/hurst-logo.f6716104.jpg";